export default "__VITE_ASSET__DI0_MnUK__"